import { finish, error } from '../../../modules/bets/actions/calculate-payout';
import api from '../../../api';
import { Amount } from 'src_common/common/amount/Amount';

export function request(dispatch, { id, accountId, legs }) {
    api.post('/bets/' + id + '/calculate-payout', { accountId, legs }).then(
        (payout) => {
            if (payout === null || payout === undefined) {
                console.warn('Payout is not a number');
                return;
            }
            return dispatch(finish(id, $appState.configState.precision.newFromOld(payout).value ));
        },
        ({ errors }) => dispatch(error(id, errors))
    );
}
